var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33997 9.19438L3.32551 6.23776C3.77235 4.89724 3.99577 4.22698 4.52442 4.10218C5.05307 3.97738 5.55265 4.47696 6.55182 5.47613L8.5229 7.44721C9.52207 8.44638 10.0217 8.94596 9.89685 9.47461C9.77206 10.0033 9.10179 10.2267 7.76127 10.6735L4.80465 11.6591C3.19149 12.1968 2.38491 12.4656 1.95915 12.0399C1.53339 11.6141 1.80225 10.8075 2.33997 9.19438Z",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.13712 10.702C7.13712 10.702 6.69485 9.37133 6.69485 8.49064C6.69485 7.60996 7.13712 6.2793 7.13712 6.2793M4.70464 11.3654C4.70464 11.3654 4.33112 9.76012 4.26237 8.71178C4.1488 6.97972 4.70464 4.28909 4.70464 4.28909",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46387 5.83687L8.54786 5.4169C8.63266 4.99288 8.93817 4.64681 9.3484 4.51006C9.75863 4.37332 10.0641 4.02725 10.1489 3.60322L10.2329 3.18326",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.249 7.1479L10.3732 7.21958C10.7565 7.44089 11.2384 7.39209 11.5696 7.09842C11.8695 6.83249 12.2966 6.76505 12.6638 6.92562L12.8338 6.99997",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.14535 1.75C5.94848 2.07203 5.99782 2.48701 6.26472 2.7539L6.32181 2.811C6.55116 3.04034 6.63573 3.37726 6.54188 3.68773",
    stroke: "#34265c",
    strokeWidth: 0.875,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91027 2.56451C8.02756 2.44723 8.0862 2.38858 8.154 2.36709C8.21136 2.34891 8.27293 2.34891 8.33028 2.36709C8.39808 2.38858 8.45673 2.44723 8.57401 2.56451C8.69129 2.68179 8.74993 2.74043 8.77143 2.80824C8.78961 2.86559 8.78961 2.92716 8.77143 2.98451C8.74993 3.05232 8.69129 3.11096 8.57401 3.22824C8.45673 3.34553 8.39808 3.40417 8.33028 3.42566C8.27293 3.44384 8.21136 3.44384 8.154 3.42566C8.0862 3.40417 8.02756 3.34553 7.91027 3.22824C7.79299 3.11096 7.73435 3.05232 7.71285 2.98451C7.69467 2.92716 7.69467 2.86559 7.71285 2.80824C7.73435 2.74043 7.79299 2.68179 7.91027 2.56451Z",
    fill: "#34265c"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3561 4.35647C11.4993 4.21333 11.5709 4.14176 11.6516 4.11065C11.7461 4.07424 11.8507 4.07424 11.9452 4.11065C12.026 4.14176 12.0975 4.21333 12.2407 4.35647C12.3838 4.49962 12.4554 4.57119 12.4865 4.65193C12.5229 4.74642 12.5229 4.85106 12.4865 4.94555C12.4554 5.02629 12.3838 5.09787 12.2407 5.24101C12.0975 5.38416 12.026 5.45573 11.9452 5.48684C11.8507 5.52324 11.7461 5.52324 11.6516 5.48684C11.5709 5.45573 11.4993 5.38416 11.3561 5.24101C11.213 5.09787 11.1414 5.02629 11.1103 4.94555C11.0739 4.85106 11.0739 4.74642 11.1103 4.65193C11.1414 4.57119 11.213 4.49962 11.3561 4.35647Z",
    fill: "#34265c"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.04086 2.2988C4.16305 2.17661 4.36116 2.17661 4.48335 2.2988C4.60554 2.42099 4.60554 2.6191 4.48335 2.74129C4.36116 2.86348 4.16305 2.86348 4.04086 2.74129C3.91867 2.6191 3.91867 2.42099 4.04086 2.2988Z",
    fill: "#34265c"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.117 8.9328C11.2392 8.81061 11.4373 8.81061 11.5595 8.9328C11.6817 9.05499 11.6817 9.2531 11.5595 9.37529C11.4373 9.49748 11.2392 9.49748 11.117 9.37529C10.9948 9.2531 10.9948 9.05499 11.117 8.9328Z",
    fill: "#34265c"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2079 5.68251C10.3301 5.56032 10.5282 5.56032 10.6504 5.68251C10.7726 5.8047 10.7726 6.00281 10.6504 6.125C10.5282 6.24719 10.3301 6.24719 10.2079 6.125C10.0857 6.00281 10.0857 5.8047 10.2079 5.68251Z",
    fill: "#34265c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/Decor.c9676d5e132ae512ce411d3e89a1ec8b.svg";
export { ForwardRef as ReactComponent };